/**
 * Valida se o valor é um número inteiro (ou vazio).
 * @param {*} valor - Valor a validar (string, number, null, undefined).
 * @returns {boolean} true se for vazio ou número inteiro válido; false caso contrário.
 */
const validarNumeroInteiro = (valor) => {
  if (valor === "" || valor === undefined || valor === null) return true;
  const n = Number(valor);
  return !Number.isNaN(n) && Number.isInteger(n);
};

export default validarNumeroInteiro;
